import React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { CCard, CCardHeader, CCardBody, CCardTitle, CRow, CCol, CImg, CTooltip } from '@coreui/react';
import moment from 'moment';
import { RootState } from '../../store/state';
import ButtonWithConfirmation from '../../shared/components/ButtonWithConfirmation';
import { ReplaceConfig, ResetConfig } from '../actions/journey';
import { PreviousJourneyConfig } from '../../shared/models/journey';
import tooltip from '../../assets/images/tool_tip.svg';

export interface ConfigVersioningProps extends DispatchProp {
  orgID: number;
  previous: PreviousJourneyConfig;
}

const ConfigVersioning = ({ orgID, previous, dispatch }: ConfigVersioningProps) => {

  const handlePreviousRevert = () => {
    dispatch(new ReplaceConfig(orgID, previous.config));
  }

  const handleDefaultRevert = () => {
    dispatch(new ResetConfig(orgID));
  }

  return (
    <CCard className="glympser-container--roundedWithShadow">
      <CCardHeader className='border-0 glympser-roundedTop'>
        <div className="d-flex align-items-center justify-content-between">
          <CCardTitle className="m-0">
            Revert Customization
            <CTooltip placement="top" content="Revert to previous changes will only revert back to the most recent changes/save made. Revert to default customization will set all changes back to Glympse PRO default.">
              <CImg src={tooltip} className="ml-2 glympser-toolTip"/>
            </CTooltip>
          </CCardTitle>
        </div>
      </CCardHeader>
      <CCardBody>
        { previous && (
          <CRow>
            <CCol lg="8">
              <p>
                Revert to the previous changes
                <br/>
                <small>
                  Version: { moment(previous?.name).format('LLL') }
                </small>
              </p>
            </CCol>
            <CCol lg="4">
              <ButtonWithConfirmation
                block
                onConfirm={ handlePreviousRevert }
                className="bg-color-orange roundedBtn"
                dialogTextProps={{
                  title: "Are you sure?",
                  bodyTxt: "By confirming you will go back to your previous customizations.",
                }}
              >Revert to Previous</ButtonWithConfirmation>
            </CCol>
          </CRow>
        ) }
        <CRow className="mt-2">
          <CCol lg="8">
            <p>Revert back to default customization</p>
          </CCol>
          <CCol lg="4">
            <ButtonWithConfirmation
              block
              onConfirm={ handleDefaultRevert }
              className="bg-color-orange roundedBtn"
              dialogTextProps={{
                title: "Are you sure?",
                bodyTxt: "By confirming you will lose all of your current customizations.",
              }}
            >Revert to Default</ButtonWithConfirmation>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
};

const mapStateToProps = (state: RootState) => ({
  orgID: state?.orgHierarchy?.selectedOrg?._id,
  previous: state?.journey?.config?.previous,
});

export default connect(mapStateToProps)(ConfigVersioning);
